(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    function formatMoney(cents) {
      var format = drawer.getAttribute('data-money-format') || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      return format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    function bindQtyButtons(root) {
      if (!root) return;
      root.querySelectorAll('[data-cart-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = this.getAttribute('data-key');
          var qty = parseInt(this.getAttribute('data-qty'), 10);
          if (qty < 0) qty = 0;

          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty })
          })
            .then(function (r) { return r.json(); })
            .then(function () { window.location.reload(); });
        });
      });
    }

    function updateCartCount(count) {
      var cartBtn = document.querySelector('[data-cart-drawer-open]');
      if (!cartBtn) return;

      var oldCount = cartBtn.querySelector('.header-cart-count');
      if (count > 0) {
        if (oldCount) {
          oldCount.textContent = count;
        } else {
          cartBtn.insertAdjacentHTML('afterbegin', '<span class="header-cart-count" aria-hidden="true">' + count + '</span>');
        }
      } else if (oldCount) {
        oldCount.remove();
      }
    }

    function refreshCart(cart) {
      var body = document.getElementById('cart-drawer-body');
      var footer = document.getElementById('cart-drawer-footer');
      if (!body || !footer || !cart) return;

      updateCartCount(cart.item_count);

      if (!cart.items || cart.items.length === 0) {
        body.innerHTML = '<p class="cart-drawer__empty">' + (drawer.getAttribute('data-empty-text') || '') + '</p>';
        footer.hidden = true;
        return;
      }

      var itemsHtml = '';
      cart.items.forEach(function (item) {
        var variantLine = '';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          variantLine = '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>';
        }
        itemsHtml += '<div class="cart-drawer__item" data-line-key="' + item.key + '">'
          + '<div class="cart-drawer__item-img">'
          + (item.image ? '<img src="' + item.image + '" alt="" width="80" height="80" loading="lazy">' : '')
          + '</div>'
          + '<div class="cart-drawer__item-info">'
          + '<p class="cart-drawer__item-title">' + item.product_title + '</p>'
          + variantLine
          + '<div class="cart-drawer__qty-row">'
          + '<button type="button" class="cart-drawer__qty-btn" data-cart-change data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">&minus;</button>'
          + '<span class="cart-drawer__qty-value">' + item.quantity + '</span>'
          + '<button type="button" class="cart-drawer__qty-btn" data-cart-change data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>'
          + '</div></div>'
          + '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>'
          + '</div>';
      });

      body.innerHTML = itemsHtml;
      footer.hidden = false;

      var priceEl = footer.querySelector('.cart-drawer__subtotal-price');
      if (priceEl) priceEl.textContent = formatMoney(cart.total_price);

      bindQtyButtons(body);
    }

    function openCart() {
      drawer.classList.add('cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeCart() {
      drawer.classList.remove('cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-cart-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openCart();
      });
    });

    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeCart);
    });

    bindQtyButtons(drawer);

    window.SkloCartDrawer = {
      open: openCart,
      close: closeCart,
      refresh: refreshCart
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["craft-axis-timeline"] && !Shopify.designMode) return;
  try {
    (function () {
    if (typeof window === 'undefined') return;
    if (window.__craftAxisTimelineInit) return;
    window.__craftAxisTimelineInit = true;

    var SECTION_SEL = '.craft-axis-timeline';
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function designMode() {
      return typeof Shopify !== 'undefined' && Shopify.designMode;
    }

    function applyLocalProgress(section, p) {
      section.style.setProperty('--craft-axis-fill', p.toFixed(4));
      var markerStart = 0.38;
      var marker = p <= markerStart ? 0 : Math.min(1, (p - markerStart) / 0.28);
      section.style.setProperty('--craft-marker', marker.toFixed(4));
      var left = Math.min(1, p / 0.48);
      var right = Math.max(0, Math.min(1, (p - 0.32) / 0.52));
      if (window.innerWidth >= 750) {
        right = left;
      }
      section.style.setProperty('--craft-col-left', left.toFixed(4));
      section.style.setProperty('--craft-col-right', right.toFixed(4));
    }

    function setFullProgress(section) {
      section.style.setProperty('--craft-axis-fill', '1');
      section.style.setProperty('--craft-marker', '1');
      section.style.setProperty('--craft-col-left', '1');
      section.style.setProperty('--craft-col-right', '1');
    }

    var raf = 0;
    function onScrollOrResize() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var sections = Array.prototype.slice.call(document.querySelectorAll(SECTION_SEL));
        if (!sections.length) return;

        if (reducedMotion.matches || designMode()) {
          sections.forEach(function (section) {
            if (reducedMotion.matches) {
              section.classList.add('craft-axis-timeline--reduced');
            } else {
              section.classList.remove('craft-axis-timeline--reduced');
            }
            setFullProgress(section);
          });
          return;
        }

        var y = window.scrollY || window.pageYOffset;
        var bounds = sections.map(function (s) {
          var r = s.getBoundingClientRect();
          var top = r.top + y;
          var bottom = top + s.offsetHeight;
          return { top: top, bottom: bottom };
        });

        var trackStart = bounds[0].top;
        var trackEnd = bounds[bounds.length - 1].bottom;
        var trackLen = Math.max(trackEnd - trackStart, 1);
        var lead = window.innerHeight * 0.42;
        var scrollRef = y + lead;
        var globalT = (scrollRef - trackStart) / trackLen;
        globalT = Math.min(1, Math.max(0, globalT));

        for (var i = 0; i < sections.length; i++) {
          var segStart = (bounds[i].top - trackStart) / trackLen;
          var segEnd = (bounds[i].bottom - trackStart) / trackLen;
          var segLen = Math.max(segEnd - segStart, 1e-4);
          var localP = (globalT - segStart) / segLen;
          localP = Math.min(1, Math.max(0, localP));
          applyLocalProgress(sections[i], localP);
        }
      });
    }

    function init() {
      document.querySelectorAll(SECTION_SEL).forEach(function (section) {
        if (reducedMotion.matches) {
          section.classList.add('craft-axis-timeline--reduced');
        } else {
          section.classList.remove('craft-axis-timeline--reduced');
        }
        section.classList.add('craft-axis-timeline--js');
      });
      onScrollOrResize();
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    reducedMotion.addEventListener('change', init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sklo-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__skloRevealBound) return;
    window.__skloRevealBound = true;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealEl(el) {
      el.classList.add('sklo-reveal--in');
    }

    function revealAll(root) {
      var items = root.querySelectorAll('.sklo-reveal:not(.sklo-reveal--in)');
      items.forEach(revealEl);
    }

    var scrollObserver;

    function initLoadRoots() {
      document
        .querySelectorAll('[data-sklo-reveal-root][data-sklo-reveal-mode="load"]:not([data-sklo-reveal-initialized])')
        .forEach(function (root) {
          root.setAttribute('data-sklo-reveal-initialized', '');
          if (reduced) {
            revealAll(root);
            return;
          }
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              revealAll(root);
            });
          });
        });
    }

    function initScrollRoots() {
      var roots = document.querySelectorAll(
        '[data-sklo-reveal-root]:not([data-sklo-reveal-mode="load"]):not([data-sklo-reveal-initialized])'
      );
      if (!roots.length) return;

      if (reduced) {
        roots.forEach(function (root) {
          root.setAttribute('data-sklo-reveal-initialized', '');
          revealAll(root);
        });
        return;
      }

      if (!scrollObserver) {
        scrollObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              revealAll(entry.target);
              scrollObserver.unobserve(entry.target);
            });
          },
          { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
        );
      }

      roots.forEach(function (root) {
        root.setAttribute('data-sklo-reveal-initialized', '');
        scrollObserver.observe(root);
      });
    }

    function init() {
      initLoadRoots();
      initScrollRoots();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
